import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';

export enum TaskModule {
  None = 0,
  LMS = 1,
  Reports = 2,
  Certificates = 3,
  RS = 4,
  Reviews = 5,
  Framework = 6,
  TalentConnecion = 7,
}

export enum TaskCategory {
  CourseConfirm = 1,
  CourseConfirmTeam = 2,
  CourseRequestStatusChange = 3,
  PreAssessment = 4,
  PostAssessment = 5,
  CourseEval = 6,
  CourseEvalTeam = 7,
  PlannedCourseDays = 8,
  CourseRequest = 9,
  Review360PeerSelect = 10,
  Review360PeerExecutor = 11,
  Review360PeerValidate = 12,
  OwnInformalConversation = 13,
  InformalConversationTeam = 14,
  ApprovalJobopening = 15,
  ActorInterview = 16,
  ApprovalPan = 17,
  LearningPath = 18,
  CertificateAssessment = 19,
  CertificateElearning = 20,
  CertificateRequirementConfirmation = 21,
  CertificateAssessmentTeam = 22,
  CertificateTeam = 23,
  CertificateResponsible = 24,
  Elearning = 25,
  CourseInPicture = 26,
  Bookmark = 27,
  CourseGroupTeam = 28,
  Review = 29,
  ReviewTeam = 30,
  PositionFlow = 31,
  NotPresence = 32,
  SkillEntryTeam = 33,
  LearningPathCourseReEnter = 34,
  ReviewTeamSetDate = 35,
  InformalConversationPeer = 36,
  Conversations = 37,
  ConversationsPeer = 38,
  ConversationsTeam = 39,
  ConversationsSign = 40,
  ConversationsSignTeam = 41,
}

export interface TaskPhoto extends IDataUrlParam {
  contentType: string;
  fileData: string;
}

export class SessionsDetails {
  courseEventSessionID: number;
  sessionDate: Date;
  sessionName: string;
  startTime: string;
  endTime: string;
  trainer: string;
  location: string;
  sessionType: string;
  local: string;
  sessionDocuments: SessionDocs[];
}
export interface SessionDocs extends IDataUrlParam {
  fileName: string;
  fileSize: string;
  contentType: string;
  fileData: string;
}
export class Task {
  studentName: string;
  module: TaskModule;
  id: number;
  name: string;
  teamName: string;
  description: string;
  startDate: Date;
  //URL: string;
  category: TaskCategory;
  courseEventEvaluationID: number;
  courseEventParticipantID: number;
  eventID: number;
  studentEvaluationID: number;
  certificateRequirementID: number;
  certificateID: number;
  certificateRequirementPerCertificateID: number;
  companyID: number;
  courseID: number;
  courseRegistrationRequestID: number;
  reviewCommentID: number;
  act: string;
  profilePicture: TaskPhoto;
  fileData: string;
  contentType: string;
  profilePictureId: number;
  preAssessmentID: number;
  postAssessmentID: number;
  learningPathStudentID: number;
  trainingVendorCourseID: number;
  eLearningParticipantID: number;
  managerStudentID: number;
  assessmentID: number;
  actionURL: string;
  dateAwarded: Date;
  location: string;
  trainer: string;
  dateConnected: Date;
  isTeamTask: boolean;
  learningPathID: number;
  studentActivityID: number;
  taskSettingDate: any;
  candidateID: number;
  candidateInterviewID: number;
  positionID: number;
  flowID: number;
  rework: number;
  countNCCHours: number;
  courseRequestKind: number;
  courseEventSessionID: number;
  inDirectReport: boolean;

  url: string;
  isTelevic: boolean;
  studentActionsSetupID: number;
  studentActionsID: number;
  startAbsence: string;

  photoId?: number;

  sessionType: string;
  local: string;
  startTime: string;
  endTime: string;
  sessionDocuments: SessionDocs[];
  sessionsDetails: SessionsDetails[];
  sessionName: string; /**/
  courseName: string;
  studentFullName: string;
  employee: string;
  studentId?: number;
  taskAsN2: boolean;
  manager: string;
  sessionsCount: number;
  courseDateFirstSession: Date;
  courseDateLastSession: Date;
  templateName: string;

  candidateFirstName: string;
  candidateLastName: string;

  whoId: number;
  createdByKindID: number;
  whoName: string;
  isPrivate: boolean;
  peerPreparationEndDate?: Date;
  genderLabel: string;

  conversationName: string;
  conversationId: number;
}

/*export class DownloadSessionDocRequest {

  courseEventSessionDocID: number;

}*/
